/**
 * i18n配置文件
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCN from './locales/zh-CN.json';
import enUS from './locales/en-US.json';
import esES from './locales/es-ES.json';

const normalizeLanguage = (language) => {
  if (!language) {
    return '';
  }
  if (language.startsWith('zh')) {
    return 'zh-CN';
  }
  if (language.startsWith('en')) {
    return 'en-US';
  }
  if (language.startsWith('es')) {
    return 'es-ES';
  }
  return language;
};

// 从localStorage获取保存的语言设置，默认为中文
const getDefaultLanguage = () => {
  const savedLanguage = localStorage.getItem('i18nextLng');
  if (savedLanguage) {
    return normalizeLanguage(savedLanguage);
  }
  // 根据浏览器语言设置默认语言
  const browserLang = navigator.language || navigator.userLanguage;
  return normalizeLanguage(browserLang) || 'en-US';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': {
        translation: zhCN
      },
      'en-US': {
        translation: enUS
      },
      'es-ES': {
        translation: esES
      }
    },
    lng: getDefaultLanguage(),
    fallbackLng: 'zh-CN',
    interpolation: {
      escapeValue: false // React已经转义了
    },
    react: {
      useSuspense: false // 兼容React 16
    }
  });

export default i18n;
